import { createSelector } from "reselect";

const artisanPrivateInquiriesStateSelector = (state) =>
  state.myArtisanPrivateInquiries;

const selectById = (state, itemId) => itemId;

export const artisanPrivateInquiriesSelector = createSelector(
  [artisanPrivateInquiriesStateSelector],
  (inquiries) => inquiries.items
);

export const artisanProposalsSelector = createSelector(
  [artisanPrivateInquiriesStateSelector],
  (proposals) => proposals.proposals
)

export const inquiryByIdSelector = createSelector(
  [artisanPrivateInquiriesSelector, selectById],
  (inquiries, _id) => {
    console.log(inquiries)
    const inquiry = inquiries.find((item) => _id === item._id);
    if (!inquiry) return null;
    return inquiry;
  }
);

export const artisanPrivateInquiriesIsLoadingSelector = createSelector(
  [artisanPrivateInquiriesStateSelector],
  (inquiries) => inquiries.isLoading
);

export const artisanPrivateInquiriesCount = createSelector(
  [artisanPrivateInquiriesStateSelector],
  (inquiries) => inquiries.count
)


export const proposalById = createSelector(
  [artisanProposalsSelector, selectById],
   (inquiries, _id) => {
    console.log(inquiries)
    const inquiry = inquiries.find((item) => _id === item._id);
    if (!inquiry) return null;
    return inquiry;
  }
)
// export const myArtisanProposals = createSelector(
//   [artisanProposalsSelector]
// )